import enLocale from "dayjs/locale/en";
import plLocale from "dayjs/locale/pl";

const servicesId = {
	egzaminlek: "lek",
	egzaminldek: "ldek",
	egzaminlekEn: "lek",
};

export const isLek = () => {
	return import.meta.env.SERVICE === "egzaminlek";
};

export const isLdek = () => {
	return import.meta.env.SERVICE === "egzaminldek";
};

export const isLekEn = () => {
	return import.meta.env.SERVICE === "egzaminlekEn";
};

export const getServiceId = () => {
	return servicesId[import.meta.env.SERVICE];
};

export const getLocale = () => {
	if (isLekEn()) {
		return enLocale;
	}

	return plLocale;
};
